import {
    addOrDelQyApi,
    uploadApi
} from "../../network/api";
const data = function () {
    return {
        msg: true,
        activeradio1: false,
        activeradio2: false,
        activeradio3: false,
        activeradio4: false,
        radio: '',
        type: '',
        img: '',
        uimg: '',
        group_name: '',
        en_name: '',
        group_code: '',
        address: '',
        en_address: '',
        username: '',
    }
};
const computed = {

}
const methods = {
    complateMsg() {
        this.msg = !this.msg
    },
    radiochange(e) {
        // console.log(e);
        if (e == '电商') {
            this.activeradio1 = true
            this.activeradio2 = false
            this.activeradio3 = false
            this.activeradio4 = false
        } else if (e == 'APP') {
            this.activeradio2 = true
            this.activeradio1 = false
            this.activeradio3 = false
            this.activeradio4 = false
        } else if (e == "游戏") {
            this.activeradio3 = true
            this.activeradio1 = false
            this.activeradio2 = false
            this.activeradio4 = false
        } else if (e == "品牌其他") {
            this.activeradio4 = true
            this.activeradio1 = false
            this.activeradio3 = false
            this.activeradio2 = false
        }
        this.type = e

    },
    final() {
        let formdata = {
            token: this.$store.state.userinfo.token,
            type: this.type,
            img: this.uimg,
            group_name: this.group_name,
            en_name: this.en_name,
            group_code: this.group_code,
            address: this.address,
            en_address: this.en_address,
            username: this.username,
        }
        addOrDelQyApi(formdata).then(res => {
            console.log(res);
            if (res.data.code == 0) {
                this.$message({
                    message: res.data.msg,
                    type: 'success'
                })
                setTimeout(() => {
                    this.$router.push({
                        path: '/perfect/Home'
                    })
                }, 500);
            } else {
                this.$message({
                    message: res.data.msg,
                })
            }
        })
    },
    handleAvatarSuccess(res, file) {
        // console.log(res);
        this.img = URL.createObjectURL(file.raw);
        this.uimg = res.data.url;
    },
    inputChange() {
        let reg = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g;
        if (this.group_code) {
            if (new RegExp(reg).test(this.group_code) == false) {
                console.log(new RegExp(reg).test(this.group_code));
                this.$message({
                    message: '只能使用18位的阿拉伯数字或大写英文字母表示！',
                    type: 'warning'
                })
            }
        }
    },
    onExceed() {
        console.log('调用了');
        this.$refs.upload.clearFiles();
    }
    // beforeUpload(file) {
    //     console.log(file);
    //     let form = new FormData()
    //     form.append('file', file)
    //     uploadApi(form).then(res => {
    //         console.log(res);
    //     })
    // }
    // UploadUrl: function () {
    //     let form = new FormData()
    //     form.append('file', file)
    //     uploadApi(form).then(res => {
    //         console.log(res);
    //     })
    //     return "返回需要上传的地址";
    // }

}



export default {
    data,
    computed,
    methods,
}